export enum BankStages {
	MAIN = 'main',
	TRANSFER = 'transfer',
	TAXES = 'taxes',
	FINES = 'fines',
}
